/**
 * Bridge for code outside the React tree (e.g. the QueryClient's
 * MutationCache), which can't call useToast(). The mounted ToastProvider
 * registers its showToast here.
 */
import type { ToastType } from "./Toast";

type ShowToast = (type: ToastType, message: string) => void;

let handler: ShowToast | null = null;

export const registerGlobalToast = (show: ShowToast | null) => {
  handler = show;
};

export const showGlobalToast: ShowToast = (type, message) => {
  handler?.(type, message);
};
